<template>
    <div class="mainBox configBox">
        <div
            class="mainLeft configTab"
            @contextmenu.stop.prevent="rightClick($event, -1)"
        >
            <div class="title">角色管理</div>
            <ul v-if="leftDataList.length">
                <li
                    v-for="(item, index) in leftDataList"
                    :key="index"
                    :class="left_id == item.id ? 'on' : ''"
                    @click="left_id = item.id"
                    @contextmenu.stop.prevent="
                        rightClick($event, index, item.is_system)
                    "
                >
                    {{ item.name }}
                </li>
            </ul>
            <el-empty description="暂无角色" v-else>
                <el-button type="primary" size="mini" @click="leftDialog = true"
                    >添加</el-button
                >
            </el-empty>
            <contextMenu ref="context-menu"></contextMenu>
        </div>

        <div class="mainRight configList">
            <el-tabs v-model="activeName">
                <el-tab-pane label="操作权限" name="first">
                    <el-form
                        :model="requestData"
                        ref="roleForm"
                        label-width="85px"
                        class="formExample mini"
                    >
                        <el-form-item prop="id" v-show="false">
                            <el-input v-model="requestData.id"></el-input>
                        </el-form-item>

                        <el-form-item></el-form-item>
                        <el-form-item label="权限列表">
                            <el-tree
                                ref="selectTree"
                                class="roleSelectTree"
                                v-if="ruleList.length"
                                :data="ruleList"
                                default-expand-all
                                check-on-click-node
                                :expand-on-click-node="false"
                                show-checkbox
                                node-key="id"
                                :props="{
                                    label: 'title',
                                    value: 'id',
                                    children: 'childrenData',
                                }"
                            ></el-tree>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="medium"
                                @click="submitForm('roleForm')"
                                >确认保存</el-button
                            >
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="数据权限" name="two">
                    <el-row
                        v-for="(item, index) in dataAuthorityLS"
                        :key="index"
                    >
                        <el-col :span="4">
                            <el-radio
                                :label="item.value"
                                v-model="requestData.data_authority"
                                >{{ item.key }}</el-radio
                            >
                        </el-col>
                        <el-col :span="6">{{ item.tips }}</el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </div>

        <!-- 角色信息修改 -->
        <el-dialog
            title="角色管理"
            custom-class="listDialog"
            width="400px"
            :visible.sync="leftDialog"
            @close="$refs.leftTabForm.resetFields()"
        >
            <el-form
                :model="leftRequestData"
                ref="leftTabForm"
                class="listForm"
            >
                <el-form-item label="名称" prop="name">
                    <el-input v-model="leftRequestData.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        v-model="leftRequestData.id"
                        v-show="false"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('leftTabForm')"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import contextMenu from '@/components/contextMenu/index.vue'
export default {
    components: { contextMenu },
    data() {
        return {
            dataAuthorityLS: [], //数据权限
            requestData: {
                //权限
                id: '',
                data_authority: '',
                operation_authority: [],
                half_list: [],
            },
            ruleList: [],
            activeName: 'first',
            leftRequestData: {
                name: '',
                id: '',
            },
            left_id: 0,
            leftDialog: false,
            leftDataList: [],
        }
    },
    watch: {
        //监听左侧分类数据变化
        left_id: function() {
            this.getRoleInfo()
        },
    },
    mounted() {
        this.getRoleLists()
    },
    methods: {
        callBackMedia(res) {
            this.rightRequestData.thumb = res.length ? res[0]['poster'] : ''
        },
        //左侧右击事件
        rightClick(e, index, is_system) {
            if (is_system == 1) return
            let _self = this
            let list = [
                {
                    label: '新增',
                    icon: 'el-icon-plus',
                    callback: (item, done) => {
                        done()
                        _self.$nextTick(() => {
                            _self.leftRequestData.name = ''
                            _self.leftRequestData.id = ''
                        })
                        _self.leftDialog = true
                    },
                },
            ]
            if (index > -1) {
                let id = _self.leftDataList[index].id
                list = list.concat([
                    {
                        label: '编辑',
                        icon: 'el-icon-edit',
                        callback(item, done) {
                            done()
                            _self.leftDialog = true
                            _self.$nextTick(() => {
                                _self.leftRequestData.name =
                                    _self.leftDataList[index].name
                                _self.leftRequestData.id =
                                    _self.leftDataList[index].id
                            })
                        },
                    },
                    {
                        label: '删除',
                        icon: 'el-icon-delete',
                        callback(item, done) {
                            done()
                            _self
                                .$confirm(
                                    '确定删除该用户？此操作不可逆！',
                                    '提示'
                                )
                                .then((result) => {
                                    _self.$api
                                        .roleDel({
                                            id: id,
                                        })
                                        .then((res) => {
                                            _self.leftDataList.splice(index, 1)
                                            _self.$commonFun.toast(
                                                '删除成功',
                                                'success'
                                            )
                                            if (id == _self.left_id) {
                                                _self.left_id =
                                                    _self.leftDataList[0].id
                                            }
                                        })
                                })
                        },
                    },
                ])
            }
            this.$refs['context-menu'].open(e, list)
        },
        //角色列表
        getRoleLists() {
            this.$api.getRoleList().then((res) => {
                this.leftDataList = res
                this.left_id = res[0].id
                this.getRoleInfo()
            })
        },
        //权限列表
        getRoleInfo() {
            let param = { id: this.left_id }
            this.$api.roleInfo(param).then((res) => {
                let _self = this
                _self.requestData.data_authority = res.data.data_authority
                _self.requestData.operation_authority =
                    res.data.operation_authority
                _self.$nextTick(() => {
                    _self.requestData.operation_authority.forEach(function(
                        item,
                        index
                    ) {
                        _self.$nextTick(() => {
                            _self.$refs.selectTree.setChecked(item, true)
                        })
                    })
                })

                this.ruleList = res.operationAuthority
                this.dataAuthorityLS = res.dataAuthority
            })
        },
        //表单提交
        submitForm(formName) {
            let _self = this
            _self.$commonFun.debounce(() => {
                _self.$refs[formName].validate((valid) => {
                    if (!valid) return
                    if (valid) {
                        if (formName == 'leftTabForm') {
                            //广告位信息更新
                            let param = _self.leftRequestData
                            _self.$api.roleUpdate(param).then((res) => {
                                console.log(param)
                                if (param.id) {
                                    //信息更新
                                    _self.leftDataList.forEach(function(
                                        item,
                                        index
                                    ) {
                                        if (item.id == param.id) {
                                            _self.leftDataList[index] = res
                                        }
                                    })
                                } else {
                                    //分类添加
                                    _self.leftDataList.push(res)
                                    if (_self.leftDataList.length == 1) {
                                        _self.left_id = res
                                    }
                                }
                                _self.$commonFun.toast('SUCCESS', 'success')
                                _self.leftDialog = false
                            })
                        }
                        if (formName == 'roleForm') {
                            _self.requestData.id = _self.left_id
                            let param = _self.requestData
                            param.half_list = _self.$refs.selectTree.getHalfCheckedKeys() //半选
                            param.operation_authority = _self.$refs.selectTree.getCheckedKeys() //全选
                            _self.$api
                                .roleAuthorityUpdate(param)
                                .then((res) => {
                                    _self.$commonFun.toast('SUCCESS', 'success')
                                })
                        }
                    }
                })
            })
        },
    },
}
</script>

<style lang="scss">
.roleSelectTree {
    margin-top: 5px;
    height: 450px;
    overflow-y: auto;
    position: relative;
    &::-webkit-scrollbar {
        width: 5px;
        height: 1px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(0, 21, 41, 0.1);
        border-radius: 30px;
    }
    &::-webkit-scrollbar-track {
        background: #fff;
    }
    .el-tree-node__content {
        height: 32px;
        background: none !important;
    }
}
</style>
